import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyBq8YBW7zoPwsf_D9AFWIcvvLxCqCIoNYU",
  authDomain: "react-instagram-clone-f2fab.firebaseapp.com",
  databaseURL: "https://react-instagram-clone-f2fab.firebaseio.com",
  projectId: "react-instagram-clone-f2fab",
  storageBucket: "react-instagram-clone-f2fab.appspot.com",
  messagingSenderId: "881612850843",
  appId: "1:881612850843:web:5464435d3550ed231ca83e",
  measurementId: "G-HP08KFWH4S"
});
const db = firebaseApp.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

export {db, auth, storage};